import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 22a7 7 0 0 0 7-7c0-3.5-2.5-6-4-8.5-.5 1.5-1.5 2.5-2.5 3 0-3-1.5-5.5-4-7.5C8.5 6 5 8.5 5 15a7 7 0 0 0 7 7"
    }, null, -1)
  ])))
}
export default { render: render }